import cmfApi from "./index";

export const getAuth = (headers) => cmfApi.get("/auth", { headers });
